// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2H35D","title":"style_title__CmFFi"};